"use client";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import overlayStyles from "../../../../css/components/overlaymodal-animations.module.css";
import Button from "../../../../components/Button";
import PharmacistSignatureModal from "../../../global/view/PharmacistSignatureModal.jsx";
import overlayTfStyles from "../css/overlayToFollows.module.css";
import { markToFollowDispensed } from "../../../../api/toFollows/toFollowsApi.js";

export function CompletedPopup({ isOpen, onClose, prescriptionId, receiptNumber, totals, barcodeValue, donePath }) {
  const navigate = useNavigate();
  
  if (!isOpen) return null;
  
  const handleDone = () => {
    console.log('[CompletedPopup] Navigation state being passed:', {
      prescriptionId,
      receiptNumber,
      totals,
      barcodeValue
    });
    onClose?.();
    if (typeof donePath === "string" && donePath.trim().length > 0) {
      try {
        sessionStorage.removeItem("currentScript");
        sessionStorage.removeItem("cameFromPriceSummary");
        sessionStorage.removeItem("cameFromOTCSummary");
        sessionStorage.removeItem("priceScriptActive");
      } catch {}
      navigate(donePath);
      return;
    }

    // Fallback: Navigate to script details page with receipt number, totals, and barcode value
    if (prescriptionId) {
      navigate(`/customer/dispensary/script/details/${prescriptionId}`, {
        state: {
          receiptNumber,
          totals,
          barcodeValue,
        },
      });
    }
  };
  
  return (
    <div className={`${overlayStyles.modalOverlay} ${overlayStyles.show}`}>
      <div className={`${overlayStyles.modalContent} ${overlayStyles.stepEnter} ${overlayTfStyles.completedModal}`}>
        <div className={overlayTfStyles.completedIcon}>✔</div>
        <h2 className={overlayTfStyles.completedTitle}>Completed</h2>
        <Button variant="primary" onClick={handleDone}>Done</Button>
      </div>
    </div>
  );
}

export default function FollowUpSignatureFlow({ isOpen, onClose, item, onDispensed }) {
  const [open, setOpen] = useState(isOpen);
  const [step, setStep] = useState("sign"); 

  useEffect(() => {
    setOpen(isOpen);
    if (isOpen) setStep("sign");
  }, [isOpen]);

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  const handleNext = async () => {
    if (!item || !item.id) {
      setStep("done");
      return;
    }

    try {
      await markToFollowDispensed(item.id);
      if (onDispensed) {
        onDispensed(item.id);
      }
      setStep("done");
    } catch (err) {
      console.error("Failed to mark to-follow as dispensed:", err);
      alert("Failed to complete follow up. Please try again.");
    }
  };

  if (!open) return null;

  return (
    <>
      <PharmacistSignatureModal
        isOpen={open && step === "sign"}
        onClose={handleClose}
        onNext={handleNext}
        openPreviewOnNext={false}
        nextLabel="Confirm"
        title="Signature Required"
      />
      <CompletedPopup isOpen={open && step === "done"} onClose={handleClose} />
    </>
  );
}
